import { __rest } from '../../_virtual/_tslib.js';
import { ListPresentation } from '@lsg/shared';
import { createElement } from 'react';
import { ListItem } from '../ListItem/ListItem.js';

/** @deprecated , has been changed to union type (Date: 05.11.2021, CB2KELD) */

var TextStyles;

(function (TextStyles) {
  TextStyles["DEFAULT"] = "copy-text";
  TextStyles["HELPER"] = "helper-text";
  TextStyles["LEAD"] = "lead-text";
})(TextStyles || (TextStyles = {}));

var List = function List(_a) {
  var isAlphabetical = _a.isAlphabetical,
      props = __rest(_a, ["isAlphabetical"]);

  return /*#__PURE__*/createElement(ListPresentation, Object.assign({}, props, {
    orderedMode: isAlphabetical ? "alphabetic" : "numeric"
  }));
};

List.Item = ListItem;
List.displayName = "List";
List.TextStyles = TextStyles;

export { List, TextStyles };
